import {
  SET_THIRD_PARTY_ACCOUNTS,
  SET_METRC_ACCOUNT,
  SET_METRC_FACILITIES,
  SET_METRC_LOCATION_TYPES,
  SET_LINX_ACCOUNTS,
  SET_QUICKBOOK_CONFIG,
  SET_QUICKBOOK_OPERATIONS,
  SET_QUICKBOOK_CATEGORIES,
  SET_QUICKBOOK_ACCOUNT_DETAILS,
  RESET,
  SET_MTRAC_ACCOUNTS,
  SET_CLOVER_ACCOUNTS,
  SET_THIRD_PARTY_PRODUCTS,
  SET_THIRD_PARTY_BRANDS,
  SET_LEAFLY_ACCOUNTS,
  SET_LEAFLY_ACCOUNT,
  SET_BIOTRACK_ACCOUNT,
  SET_UTAH_ICS_ACCOUNT,
} from '../types/thirdParty'

const initState = {
  thirdPartyAccounts: {},
  metrcAccounts: [],
  metrcFacilities: [],
  lastModified: new Date().getTime(),
  linxAccounts: {},
  quickbook: {},
  reset: {},
  quickbookProductCat: [],
  mtracAccounts: {},
  cloverAccounts: {},
  thirdPartyProducts: [],
  leaflyAccount: {},
  leaflyAccounts: {},
  biotrackAccount: {},
  utahIcsAccount: {},
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_THIRD_PARTY_ACCOUNTS:
      return {
        ...state,
        thirdPartyAccounts: action.payload.thirdPartyAccounts,
        lastModified: new Date().getTime(),
      }
    case SET_METRC_ACCOUNT:
      return {
        ...state,
        metrcAccounts: action.payload.metrcAccount,
        lastModified: new Date().getTime(),
      }
    case SET_METRC_FACILITIES:
      return {
        ...state,
        metrcFacilities: action.payload.metrcFacilities,
        lastModified: new Date().getTime(),
      }
    case SET_METRC_LOCATION_TYPES:
      return {
        ...state,
        metrcLocationTypes: action.payload.metrcLocationTypes,
        lastModified: new Date().getTime(),
      }
    case SET_LINX_ACCOUNTS:
      return {
        ...state,
        linxAccounts: action.payload.linxAccounts,
        lastModified: new Date().getTime(),
      }
    case SET_QUICKBOOK_CONFIG:
      return { ...state, quickbook: action.payload.quickbook }
    case SET_QUICKBOOK_OPERATIONS:
      return { ...state, quickBookOperations: action.payload.quickbookOpt }
    case SET_QUICKBOOK_CATEGORIES:
      return { ...state, quickbookProductCat: action.payload }
    case SET_QUICKBOOK_ACCOUNT_DETAILS:
      return { ...state, quickbook: action.payload }
    case RESET:
      return { ...state, reset: action.payload }
    case SET_MTRAC_ACCOUNTS:
      return { ...state, mtracAccounts: action.payload }
    case SET_CLOVER_ACCOUNTS:
      return { ...state, cloverAccounts: action.payload }
    case SET_THIRD_PARTY_PRODUCTS:
      const { thirdPartyProducts = {} } = state
      const { productId } = action.payload
      const updatedProducts = { ...thirdPartyProducts }
      updatedProducts[productId] = action.payload.thirdPartyProducts

      return {
        ...state,
        thirdPartyProducts: action.payload.thirdPartyProducts,
        lastModified: new Date().getTime(),
      }
    case SET_THIRD_PARTY_BRANDS:
      return {
        ...state,
        thirdPartyBrands: action.payload.thirdPartyBrands,
        lastModified: new Date().getTime(),
      }
    case SET_LEAFLY_ACCOUNTS:
      return { ...state, leaflyAccounts: action.payload, lastModified: new Date().getTime() }
    case SET_LEAFLY_ACCOUNT:
      return { ...state, leaflyAccount: action.payload, lastModified: new Date().getTime() }
    case SET_BIOTRACK_ACCOUNT:
      return { ...state, biotrackAccount: action.payload.biotrackAccount[0] }
    case SET_UTAH_ICS_ACCOUNT: {
      const utahIcsAccount = Array.isArray(action.payload.utahIcsAccount)
        ? action.payload.utahIcsAccount[0]
        : action.payload.utahIcsAccount
      return {
        ...state,
        utahIcsAccount,
        lastModified: new Date().getTime(),
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/thirdParty.js